export const ERROR_MESSAGES = {
  invalidEmail: {
    hr: 'Molimo ispravno unesite email adresu.',
    en: 'Please enter the correct email address.'
  },
  invalidPhoneNumber: {
    hr: 'Molimo ispravno unesite broj telefona.',
    en: 'Please enter the correct phone number.'
  },
  recaptchaUnchecked: {
    hr: 'Molimo označite potvrdni okvir.',
    en: 'Please check the box.'
  },
  requestError: {
    hr: 'Došlo je do pogreške prilikom slanja zahtjeva.',
    en: 'An error occurred while sending the request.'
  },
  oldPasswordIncorrect: {
    hr: 'Niste unijeli ispravnu staru zaporku.',
    en: 'You have not entered the correct old password.'
  },
  allFieldsRequired: {
    hr: 'Sva obavezna polja moraju biti popunjena.',
    en: 'All mandatory fields must be filled.'
  },
  passwordFieldsMustMatch: {
    hr: 'Polja "Nova lozinka" i "Ponovi novu lozinku" moraju biti ista.',
    en: 'The fields "New password" and "Repeat new password" must be the same.'
  },
  error: {
    hr: 'Greška',
    en: 'Error.'
  },
  errorTryAgain: {
    hr: 'Greška, pokušajte ponovno.',
    en: 'Error, please try again.'
  },
  alreadyHasAccount: {
    hr: 'Za upisanu email adresu već postoji korisnički profil, ukoliko niste sigurni koja vam je lozinka, možete je resetirati na idućem linku:',
    en: 'There is already a user profile for the entered email address, if you are not sure what your password is, you can reset it at the following link:'
  },
  termsOfSaleRequired: {
    hr: 'Potrebno je prihvatiti uvjete prodaje.',
    en: 'It is necessary to accept the terms of sale.'
  },
  noTickets: {
    hr: 'Trenutno nemate kupljenih ulaznica!',
    en: 'You currently have no purchased tickets!'
  },
  invalidDate: {
    hr: 'Neispravan unos datuma!',
    en: 'Invalid date entry!'
  },
  dateInFuture: {
    hr: 'Datum ne može biti u budućnosti!',
    en: 'The date cannot be in the future!'
  },
  maxTicketsInCart: {
    hr: 'Maksimalni broj ulaznica u košarici!',
    en: 'Maximum number of tickets in the cart!'
  },
  addToCartError: {
    hr: 'Pogreška kod dodavanja u košaricu!',
    en: 'Error adding to cart!'
  },
  notEnoughTicketsInSector: {
    hr: 'U odabranom sektoru nema dovoljno ulaznica koliko ste odabrali za kupovinu. Molimo ponovite postupak kupovine.',
    en: 'There are not enough tickets in the selected sector as you have chosen to purchase. Please repeat the purchase process.'
  },
  maxSelectedTicketsInCart: {
    hr: 'Odabrali ste maksimalni broj ulaznica koje možete staviti u košaricu!',
    en: 'You have selected the maximum number of tickets you can put in the cart!'
  },
  freeTicketsInCart: {
    hr: 'U košarici se već nalaze besplatne ulaznice te u istu košaricu nije moguće dodati ulaznice s cijenom. Ako želite kupiti ulaznice, potrebno je dovršiti trenutni proces preuzimanja besplatnih ulaznica ili odustati od istog (klikom na gumb "Odustani" u košarici).',
    en: 'There are already free tickets in the cart and it is not possible to add tickets with a price to the same cart. If you want to buy tickets, you need to complete the current process of picking up free tickets or cancel it (by clicking the "Cancel" button in the cart).'
  },
  ticketsInCartWithPrice: {
    hr: 'U košarici se već nalaze ulaznice s cijenom te u istu košaricu nije moguće dodati besplatne ulaznice. Ako želite preuzeti besplatne ulaznice, potrebno je dovršiti trenutni proces kupovine ulaznica ili odustati od istog (klikom na gumb "Odustani" u košarici).',
    en: 'There are already tickets with a price in the cart and it is not possible to add free tickets to the same cart. If you want to pick up free tickets, you need to complete the current process of purchasing tickets or cancel it (by clicking the "Cancel" button in the cart).'
  },
  alreadyHasTicket: {
    hr: 'Označena osoba već ima ulaznicu ili je u procesu kupovine.',
    en: 'The marked person already has a ticket or is in the process of purchasing.'
  },
  contactClubForThisUser: {
    hr: 'Za kupovinu ulaznice za označenu osobu javite se klubu.',
    en: 'To purchase a ticket for the marked person, please contact the club.'
  },
  membershipNotFound: {
    hr: 'Nepostojeća članska.',
    en: 'Non-existent membership.'
  },
  membershipDataNotMatch: {
    hr: 'Podaci s članske se ne podudaraju s upisanim podacima.',
    en: 'The data on the membership does not match the entered data.'
  },
  membershipAlreadyUsed: {
    hr: 'S ovom članskom iskaznicom je već primjenjen popust.',
    en: 'This membership card has already been used.'
  },
  membershipDiscountFailed: {
    hr: 'Neuspjela primjena popusta.',
    en: 'Failed to apply discount.'
  },
  membershipHasAnnualTicket: {
    hr: 'Vlasnik članske iskaznice unesenog barkoda također posjeduje i godišnju ulaznicu te stoga ne može iskoristiti pogodnost besplatnih ulaznica za članove.',
    en: 'The owner of the membership card with the entered barcode also has an annual ticket and therefore cannot take advantage of the free tickets for members.'
  },
  userError: {
    hr: 'Greška kod označene osobe.',
    en: 'Error with the marked person.'
  },
  membershipNotFoundWithBarcode: {
    hr: 'Nije pronađena članska iskaznica s unesenim barkodom.',
    en: 'No membership card found with the entered barcode.'
  },
  membershipContactClub: {
    hr: 'Za kupovinu ulaznice za označenu člansku iskaznicu javite se klubu.',
    en: 'To purchase a ticket for the marked membership card, please contact the club.'
  },
  membershipAlreadyHasTicket: {
    hr: 'Za člansku iskaznicu unesenog barkoda već je kupljena ulaznica ili je u procesu kupovine.',
    en: 'A ticket has already been purchased for the membership card with the entered barcode or is in the process of purchasing.'
  },
  membershipMaxFreeTickets: {
    hr: 'Za člansku iskaznicu unesenog barkoda iskorišten je maksimalan broj besplatnih ulaznica u jednoj godini.',
    en: 'The maximum number of free tickets in one year has been used for the membership card with the entered barcode.'
  },
  membershipHasAnnualTicketWithBarcode: {
    hr: 'Vlasnik članske iskaznice unesenog barkoda također posjeduje i godišnju ulaznicu te stoga ne može iskoristiti pogodnost besplatnih ulaznica za članove.',
    en: 'The owner of the membership card with the entered barcode also has an annual ticket and therefore cannot take advantage of the free tickets for members.'
  },
  membershipInvalidBarcode: {
    hr: 'Provjerite upisane barkodove članskih iskaznica i pokušajte ponovno.',
    en: 'Check the entered barcodes of the membership cards and try again.'
  },
  membershipAlreadyUsedWithBarcode: {
    hr: 'Članska iskaznica s unesenim barkodom već je korištena.',
    en: 'The membership card with the entered barcode has already been used.'
  },
  multipleSamePerson: {
    hr: 'Upisali ste istu osobu više puta.',
    en: 'You have entered the same person multiple times.'
  },
  ticketsUsers: {
    hr: 'korisnici ulaznice broj',
    en: 'ticket users number'
  },
  postalCodeDigits: {
    hr: 'Poštanski broj treba sadržavati 5 znamenaka.',
    en: 'The postal code must contain 5 digits.'
  },
  errorWhenSendingData: {
    hr: 'Greška prilikom slanja podataka',
    en: 'Error when sending data'
  },
  dataDoesntMatch: {
    hr: 'Pogrešan email ili lozinka!',
    en: 'Incorrect email or password!'
  },
  invalidEmailFormat: {
    hr: 'Neispravan unos email adrese.',
    en: 'Invalid email address.'
  },
  consentImgErrMsg: {
    hr: 'Morate dati pristanak na obradu podataka i učitati sliku.',
    en: 'You must give consent for data processing and upload a photo.'
  },
  consentDataErrMsg: {
    hr: 'Morate dati pristanak na obradu podataka.',
    en: 'You must give consent for data processing.'
  },
  imageUploadError: {
    hr: 'Morate učitati sliku.',
    en: 'You must upload a photo.'
  },
  barcodeRequired: {
    hr: 'Unesite barkod',
    en: 'Enter barcode'
  },
  invalidBarcode: {
    hr: 'Uneseni barkod nije ispravan.',
    en: 'The entered barcode is not valid.'
  },
  seasonTicketNameMismatch: {
    hr: 'Ime i prezime s godišnje ulaznice ne odgovara imenu i prezimenu na profilu. Za povezivanje drugih godišnjih ulaznica odaberite "Ostale godišnje".',
    en: 'The name and surname on the annual ticket do not match the name and surname on the profile. To connect other annual tickets, select "Other annual".'
  },
  seasonTicketAlreadyAdded: {
    hr: 'Komplet ulaznica je već dodana na profil.',
    en: 'The ticket set has already been added to the profile.'
  },
  seasonTicketAndBirthDateDoesntMatch: {
    hr: 'Kombinacija barkoda i datum rođenja ne postoji.',
    en: 'The combination of barcode and date of birth does not exist.'
  },
  seasonTicketNameAndProfileMatch: {
    hr: 'Ime i prezime s godišnje ulaznice odgovara imenu i prezimenu na profilu. Za povezivanje svoje godišnje ulaznice odaberite "Moja godišnja".',
    en: 'The name and surname on the annual ticket match the name and surname on the profile. To connect your annual ticket, select "My annual".'
  },
  connectingError: {
    hr: 'Greška! Povezivanje nije uspjelo.',
    en: 'Error! Connection failed.'
  },
  postalCodeNotFound: {
    hr: 'Poštanski broj nije pronađen, molimo unesite ispravan.',
    en: 'Postal code not found, please enter a valid one.'
  },
  purchaseContinuationDisabled: {
    hr: 'Nastavak kupovine je onemogućen. Za više detalja obratite se na prodajno mjesto organizatora.',
    en: 'Purchase continuation is disabled. For more details, please contact the organizer\'s sales point.'
  },
  purchaseInProgress: {
    hr: 'Kupac ima aktivnu karticu ili je u procesu kupovine.',
    en: 'The buyer has an active card or is in the process of purchasing.'
  },
  membershipBirthDateMsg: {
    hr: 'Kako biste se mogli uspješno učlaniti, molimo vas da provjerite vaše podatke i osigurate da ste unijeli ispravan datum rođenja. Ako ste punoljetni i želite se pridružiti klubu, učlanjenje je moguće samo kao vlasnik profila odabirom opcije "Učlanjujem sebe", dok ostali članovi vlasnika profila mogu biti samo maloljetna djeca.',
    en: 'In order to successfully register, please check your data and ensure that you have entered the correct date of birth. If you are an adult and wish to join the club, registration is only possible as the owner of the profile by selecting the option "I am joining myself", while other members of the profile owner can only be minor children.'
  },
  membershipInvalidBirthDateMsg: {
    hr: '"Pokušavate učlaniti maloljetnu osobu. Učlanjenje osoba mlađih od 16 godina moguće je samo na blagajni kluba."',
    en: '"You are trying to register a minor. Registration of persons under the age of 16 is only possible at the box office."'
  },
  invalidOIB: {
    hr: 'Neispravan OIB',
    en: 'Invalid OIB'
  },
  fileTooLarge: {
    hr: 'Datoteka koju pokušavate učitati je prevelika. Molimo odaberite manju datoteku ili smanjite veličinu PDF-a prije učitavanja.',
    en: 'The file you are trying to upload is too large. Please select a smaller file or reduce the size of the PDF before uploading.'
  },
  chooseMembershipType: {
    hr: 'Potrebno je odabrati koga učlanjujete.',
    en: 'You need to choose who you are registering.'
  },
  requiredToChooseSex: {
    hr: 'Potrebno je odabrati spol.',
    en: 'You must select a gender.'
  },
  requiredToAcceptAllFields: {
    hr: 'Potrebno je prihvatiti sva obvezna polja.',
    en: 'You must accept all mandatory fields.'
  },
  invalidBirthDate: {
    hr: 'Neispravan datum rođenja.',
    en: 'Invalid date of birth.'
  },
  invalidData: {
    hr: 'Neispravni podaci.',
    en: 'Invalid data.'
  },
  nameAndSurnameMismatch: {
    hr: 'Ne poklapaju se ime i prezime s vaše članske iskaznice i s vašeg profila.',
    en: 'The name and surname on your membership card do not match those on your profile.'
  },
  membershipAlreadyLinked: {
    hr: 'Članska iskaznica je već povezana s profilom.',
    en: 'The membership card is already linked to the profile.'
  },
  membershipIsAdultConnectErrMsg: {
    hr: 'Član kojeg pokušavate povezati je punoljetan. Možete povezati samo maloljetnu djecu.',
    en: 'The member you are trying to connect is of legal age. You can only connect minor children.'
  },
  membershipExpired: {
    hr: 'Oops! Članstvo je isteklo te se ne može povezati, no moguće je kupiti novo članstvo.',
    en: 'Oops! The membership has expired and cannot be linked, but it is possible to purchase a new membership.'
  },
  membershipInvalidBirthDateOrUnderAge: {
    hr: 'Neispravan datum rođenja člana ili je član maloljetan.',
    en: 'Invalid date of birth of the member or the member is a minor.'
  },
  invalidPIN: {
    hr: 'Neispravan PIN.',
    en: 'Invalid PIN.'
  },
  matchingDataMembershipAndSeasonTicket: {
    hr: 'Vlasnik članske iskaznice treba biti isti kao i vlasnik godišnje ulaznice. Podaci se ne podudaraju. Za više informacija obratite se Odjelu za članstvo s osobnim podacima (ime, prezime, datum rođenja, OIB i adresa) na mail ',
    en: 'The owner of the membership card must be the same as the owner of the annual ticket. The data does not match. For more information, please contact the Membership Department with your personal data (name, surname, date of birth, OIB and address) at'
  },
  membershipNotActive: {
    hr: 'Članska iskaznica nije aktivna.',
    en: 'Membership card is not active.'
  },
  seasonTicketReservationNotFound: {
    hr: 'Ne postoji rezervacija za upisani barkod godišnje pretplate.',
    en: 'No reservation exists for the entered barcode of the annual ticket.'
  },
  seasonTicketReservationCancelled: {
    hr: 'Rezervacija za upisani barkod godišnje pretplate je poništena.',
    en: 'The reservation for the entered barcode of the annual ticket has been cancelled.'
  },
  seasonTicketReservationIssued: {
    hr: 'Rezervacija za upisani barkod godišnje pretplate je već izdana. Ako ste već bili u procesu kupovine molimo Vas da pričekate 30 minuta za ponovnu kupovinu.',
    en: 'The reservation for the entered barcode of the annual ticket has already been issued. If you were already in the purchasing process, please wait 30 minutes for a new purchase.'
  },
  noResultsForEnteredData: {
    hr: 'Nema rezultata za unesene podatke!',
    en: 'No results for the entered data!'
  },
  errorAddingCard: {
    hr: 'Greška prilikom dodavanja kartice. Molimo pokušajte ponovno.',
    en: 'Error adding card. Please try again.'
  },
  seatsAlreadyTaken: {
    hr: 'Odabrana mjesta su već zauzeta!',
    en: 'The selected seats are already taken!'
  },
  errorMissingData: {
    hr: 'Google prijava nije uspjela, molimo prijavite se putem emaila i lozinke.',
    en: 'Google login failed, please log in with email and password.'
  },
  noLetters: {
    hr: 'Označena polja moraju sadržavati barem jedno slovo!',
    en: 'The marked fields must contain at least one letter!'
  },
  seatsBetweenSelected: {
    hr: 'Jedno zasebno sjedalo ne smije ostati slobodno.',
    en: 'One separate seat must not remain free.'
  },
  maxTicketsSelected: {
    hr: 'Odabran maksimalni broj ulaznica.',
    en: 'Maximum number of tickets selected.'
  },
  discountChangeFailed: {
    hr: 'Transakcija je zaključana i nije ju moguće više mijenjati. Učitajte stranicu ponovno i završite svoju transakciju.',
    en: 'The transaction is locked and cannot be changed anymore. Please reload the page and complete your transaction.'
  }
};
